import React, { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { Sun, Moon } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Button } from "./ui/button";

const ClinicalThemeToggle = ({ compact = false }) => {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const { t } = useLanguage();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const activeTheme = mounted ? resolvedTheme || theme : "clinical-light";
  const isDark = activeTheme === "clinical-dark";

  const toggle = () => {
    setTheme(isDark ? "clinical-light" : "clinical-dark");
  };

  if (!mounted) {
    return (
      <Button
        type="button"
        variant="outline"
        size={compact ? "sm" : "default"}
        className={compact ? "h-8 w-8 p-0 text-primary" : "gap-2 text-primary"}
        aria-hidden="true"
        tabIndex={-1}
        disabled
      />
    );
  }

  return (
    <Button
      type="button"
      variant="outline"
      size={compact ? "sm" : "default"}
      onClick={toggle}
      className={compact ? "h-8 w-8 p-0 text-primary" : "gap-2 text-primary"}
      aria-label={isDark ? t("theme.switchToLight") : t("theme.switchToDark")}
      data-testid="clinical-theme-toggle"
    >
      {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
      {!compact && (
        <span className="text-sm">{isDark ? t("theme.light") : t("theme.dark")}</span>
      )}
    </Button>
  );
};

export default ClinicalThemeToggle;
